import { render, staticRenderFns } from "./SalesPaymentList.vue?vue&type=template&id=5c0d1d2d"
import script from "./SalesPaymentList.vue?vue&type=script&lang=js"
export * from "./SalesPaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports